<template>
  <div>
    <center><h6>Debt</h6></center>
    <h5 class="info-text">Debt can stop you from growing your money</h5>
    <div class="row justify-content-center">
      
      <div class="col-12 col-sm-10 mt-3">
        
        <fg-input label="How much money are you owing? (required)"
          type="number"
          name="debt"
          :error="getError('debt')"
          v-validate="modelValidations.debt"
          v-model="model.debt"
        >
        </fg-input>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    
    data() {
      return {
        model: {
          debt: ''
        },
        modelValidations: {
          debt: {
            required: true
          }
        }
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model)
          return res
        })
      }
    }
  }
</script>
<style lang="scss">
  .card-wizard .picture-container .picture {
    input[type="file"] {
      display: none;
    }
  }
</style>
